export const TOGGLE_CHECK = 'TOGGLE_CHECK';

export const toggleCheck = (id) => ({
  type: TOGGLE_CHECK,
  payload: id,
});